// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3E_5P","newExpiryDate":"styles_newExpiryDate__2iNgN","footer":"styles_footer__18QEc"};